export default __webpack_public_path__ + "static/media/dwarf02.ca7f5d26.jpg";